<script>
import { formatTimestamp } from '../utils/formatTimestamp'
import { api } from '../../../firebase'
import { toDataUri } from '../../../helpers/toDataUri'
import NoData from '../common-components/table/NoData'

export default {
  name: 'MobilizeV2ImageTemplatesTable',
  props: {
    showActions: { type: Boolean, default: true },
    value: { type: Array, required: false, default: () => [] }
  },
  components: {
    NoData
  },
  computed: {
    headers() {
      const headers = [
        {
          text: 'ID',
          sortable: true,
          value: 'id'
        },
        {
          text: 'Name',
          sortable: true,
          value: 'data.name'
        },
        { text: 'Enabled', value: 'data.enabled', sortable: true },
        { text: 'Image', value: 'data.image', sortable: false },
        { text: 'Created', value: 'createTime', sortable: true },
        { text: 'Last modified', value: 'updateTime', sortable: true }
      ]

      if (this.showActions) {
        headers.push({
          text: 'Actions',
          sortable: false,
          value: 'actions'
        })
      }

      return headers
    },
    formatTimestamp() {
      return formatTimestamp
    },
    toDataUri() {
      return toDataUri
    },
    imageTemplates() {
      return this.$attrs.items
    }
  },
  inheritAttrs: false,
  methods: {
    async disableItem(id) {
      try {
        const { result } = await api.imageTemplates.disable({ id })
        const item = this.imageTemplates.find(item => item.id === id)
        if (item) {
          Object.assign(item, result)
        }
        this.$toast.success('Image template disabled successfully.')
      } catch (_) {
        this.$toast.error('Disabling the image template failed. Please try again.')
      }
    },
    async enableItem(id) {
      try {
        const { result } = await api.imageTemplates.enable({ id })
        const item = this.imageTemplates.find(item => item.id === id)
        if (item) {
          Object.assign(item, result)
        }
        this.$toast.success('Image template enabled successfully.')
      } catch (_) {
        this.$toast.error('Enabling the image template failed. Please try again.')
      }
    }
  }
}
</script>

<template>
  <v-data-table
    item-key="id"
    class="elevation-1"
    loading-text="Loading..."
    :headers="headers"
    :value="value"
    @input="$emit('input', $event)"
    v-bind="$attrs"
  >
    <template v-slot:[`item.id`]="{ item }">
      <router-link :to="'/mobilizev2/image-templates/' + item.id">
        {{ item.id }}
      </router-link>
    </template>
    <template v-slot:[`item.data.name`]="{ item }">
      <router-link :to="'/mobilizev2/image-templates/' + item.id">
        {{ item.data.name }}
      </router-link>
    </template>
    <template v-slot:[`item.data.enabled`]="{ item }">
      <span>
        {{ item.data.enabled ? 'Yes' : 'No' }}
      </span>
    </template>
    <template v-slot:[`item.data.image`]="{ item }">
      <img :src="toDataUri(item.data.image, 'image/svg+xml')" />
    </template>
    <template v-slot:[`item.createTime`]="{ item }">
      <span>{{ formatTimestamp(item.createTime) }}</span>
    </template>
    <template v-slot:[`item.updateTime`]="{ item }">
      <span>{{ formatTimestamp(item.updateTime) }}</span>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon v-if="item.data.enabled" small @click="disableItem(item.id)">
        block
      </v-icon>
      <v-icon v-else small @click="enableItem(item.id)">
        done
      </v-icon>
    </template>
    <template v-slot:no-data>
      <no-data dataType="image template" link="/mobilizev2/image-templates/new" image="image-template.png" />
    </template>
  </v-data-table>
</template>

<style></style>
